import { createStyleSheet } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  container: {
    position: 'relative',
  },
  block: {
    backgroundColor: theme.COLOR_BG_FILL,
    borderRadius: rw(5),
    overflow: 'hidden',
  },
}))
